var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg011Instagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.273,0H148.728C66.719,0,0,66.719,0,148.728v214.544C0,445.281,66.719,512,148.728,512h214.544 c23.662,0,46.291-5.399,67.26-16.049c19.98-10.146,37.717-24.968,51.293-42.864c6.675-8.799,4.954-21.345-3.846-28.021 c-8.797-6.675-21.344-4.956-28.021,3.846C429.183,456.295,397.588,472,363.273,472H148.728C88.775,472,40,423.225,40,363.273 V148.728C40,88.775,88.775,40,148.728,40h214.544C423.225,40,472,88.775,472,148.728V343c0,11.046,8.954,20,20,20 c11.046,0,20-8.954,20-20V148.728C512,66.719,445.281,0,363.273,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,118c-76.094,0-138,61.906-138,138s61.906,138,138,138s138-61.906,138-138S332.094,118,256,118z M256,354 c-54.037,0-98-43.963-98-98s43.963-98,98-98s98,43.963,98,98S310.037,354,256,354z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 116,
    r: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg011Instagram);
export default __webpack_public_path__ + "static/media/011-instagram.f15877b0e883bb80b4359f39c0f2803e.svg";
export { ForwardRef as ReactComponent };